<template>
  <div class="row segmentForm">
    <div v-if="modalForm.isEmptyDiv">
      <div class="row">
        <div class="col-12" style="border-bottom: 1px solid #f3f3f3;">
          <h5>Information</h5>
        </div>
        <div class="mt-2">
          <span>test</span>
        </div>
        <!--<div class="col-12">
          <font-awesome-icon icon="check" color="#538c79" size="lg" class="icon"/>
          <span class="mx-2">İzin var</span><br>
          <font-awesome-icon icon="times" color="#b66666" size="lg" class="icon"/>
          <span class="mx-2">İzin yok</span>
        </div>-->

      </div>
    </div>
    <div v-if="modalForm.isActiveModal" class="border rounded-4 mx-lg-2" style="padding: 10px">
      <div v-if="segmentForm.id != null" class="row" style="padding: 5px;">
        <div class="col-10">
          <h5>Edit Segment / {{segmentForm.segmentName}}</h5>
        </div>
      </div>
      <div v-else style="padding: 5px;">
        <h5>Add Segment</h5>
      </div>
      <div class="pt-2" style="border-top: 1px solid #f3f3f3;padding: 10px">
        <div class="mb-3">
          <label class="form-label float-start">Segment Name</label>
          <div class="input-group">
            <input type="text" class="form-control" v-model="segmentForm.segmentName" required
                   maxlength="50">
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label float-start">System Name</label>
          <select class="form-select" v-if="segmentForm.id!=null" v-model="segmentForm.id">
            <option v-if="segmentForm.id != null" :value="segmentForm.id" selected>
              {{segmentForm.system}}
            </option>
            <option v-for="system in systems" :key="system.id" :value="system.id">
              {{system.ldapAliasName}}
            </option>
          </select>
          <select v-else class="form-select"  v-model="segmentForm.systemId">
            <option v-for="system in systems" :key="system.id" :value="system.id">
              {{system.ldapAliasName}}
            </option>
          </select>
        </div>
        <div class="mb-3">
          <label class="form-label float-start">Mail Adress</label>
          <div class="input-group">
            <input v-model="segmentForm.syncMail" class="form-control" required maxlength="50">
          </div>
        </div>
        <label class="form-label float-start">Mail Password</label>
        <div class="input-group">
          <input v-model="segmentForm.syncMailPassword" class="form-control" required maxlength="50">
        </div>
        <div v-if="segmentForm.id != null" class="row mt-2" style="border-top: 1px solid #f3f3f3">
          <div class="mt-2 col-6">
            <button @click="TrySyncData(segmentForm.id)" class="btn btn-group" data-bs-toggle="modal"  data-bs-target="#LdapUserList">
              <font-awesome-icon title="Sync This Segment" icon="sync" class="icon" style="height: 20px"/>
            </button>
            <button @click="TryDeleteSegment(segmentForm.id,segmentForm.segmentName)" title="Delete This Segment" class="btn btn-group">
              <font-awesome-icon icon="trash-alt" class="icon modified-color-red" style="height: 20px"/>
            </button>
          </div>
          <div class="col-6 text-end">
            <button class="btn btn-success mt-2" @click="TryAddSegment(segment)">
              <font-awesome-icon icon="edit"/>
              <span class="mx-1">Update</span>
            </button>
          </div>
        </div>
        <div v-else class="text-end mt-2" style="border-top: 1px solid #f3f3f3">
          <button class="btn mt-2" @click="TryAddSegment(segmentForm)" style="background-color: #56759c;color: #ffffff">
            <font-awesome-icon icon="save"/>
            <span class="mx-1">Save</span>
          </button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {createNamespacedHelpers} from "vuex";

const {mapActions} = createNamespacedHelpers('ldapsync');

export default {
  name: "LdapSideForm",
  props: ["segmentForm", "modalForm", "systems",],
  data(){
    return {
      syncLoading: false,
    }
  },
  methods: {
    ...mapActions(["getSegments","AddSegment","deleteSegment","syncData"]),

    async TryGetSegments() {
      try {
        this.getSegments();
      } catch (e) {
        this.$notify({title: "Error", type: "error", text: e.message});
      } finally {
        this.$notify();
      }
    },
    async TryAddSegment(value) {
      try {
        await this.AddSegment(value);
        this.$notify({title: "Success", type: "success", text: "Project succesfully adding."})
        this.segmentForm = {}
      } catch (e) {
        this.$notify({title: "Error", type: "error", text: e})
      }
      this.TryGetSegments();
    },
    async TryDeleteSegment(value, valuename) {
      await this.$swal({
        title: '<p style="text-align: left;font-size: 22px;">You are about to delete the "' + valuename + '" segment. Are you sure?</p>',
        html: "",
        showCancelButton: true,
        cancelButtonText: 'No',
        cancelButtonColor: '#ec2929d4',
        confirmButtonColor: '#1e3e67',
        confirmButtonText: 'Yes',
      }).then(async (response) => {
        if (response.value) {
          try {
            await this.deleteSegment(value);
            this.$notify({
              title: "Success",
              text: "Segment deleted successfully. ",
              type: "success"
            });

          } catch (e) {
            this.$notify({
              title: "Error",
              text: "Failed to delete segment.." + e.message,
              type: "error"
            });
          }
        }
      });
    },
    async TrySyncData(value) {
      this.syncLoading = true;
      try {
        await this.syncData(value);
        this.$notify({title: "Success", type: "success", text: "Sync completed successfully"})

      } catch (e) {
        this.$notify({title: "Error", type: "error", text: e.message});
      } finally {
        this.syncLoading = false;
        this.isActiveSyncDataList = true;
      }
    },
  }
}
</script>

<style scoped>

</style>